(function () {
  const SELECTOR = 'media-gallery[data-coverflow-gallery]';
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function updateCounter(gallery, swiper) {
    const current = gallery.querySelector('.slider-counter--current');
    const total = gallery.querySelector('.slider-counter--total');
    if (current) current.textContent = String(swiper.activeIndex + 1);
    if (total) total.textContent = String(swiper.slides.length);
  }

  function setSlideA11y(swiper) {
    swiper.slides.forEach((slide, index) => {
      const isActive = index === swiper.activeIndex;
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      slide.querySelectorAll('button, a, iframe, video, model-viewer, [tabindex]').forEach((element) => {
        if (isActive) {
          if (element.dataset.coverflowTabindex) {
            element.setAttribute('tabindex', element.dataset.coverflowTabindex);
            delete element.dataset.coverflowTabindex;
          } else if (element.getAttribute('tabindex') === '-1') {
            element.removeAttribute('tabindex');
          }
          return;
        }

        const tabindex = element.getAttribute('tabindex');
        if (tabindex && tabindex !== '-1') element.dataset.coverflowTabindex = tabindex;
        element.setAttribute('tabindex', '-1');
      });
    });
  }

  function activateFromSwiper(gallery, swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const mediaId = activeSlide?.dataset?.mediaId;
    if (!mediaId) return;

    gallery.setActiveMedia?.(mediaId, false, { fromCoverflow: true });
    updateCounter(gallery, swiper);
    setSlideA11y(swiper);

    gallery.dispatchEvent(
      new CustomEvent('slideChanged', {
        detail: {
          currentPage: swiper.activeIndex + 1,
          currentElement: activeSlide,
        },
      })
    );
  }

  function destroyGallery(gallery) {
    if (!gallery?.coverflowSwiper || gallery.coverflowSwiper.destroyed) return;
    gallery.coverflowSwiper.destroy(true, true);
    gallery.setCoverflowSwiper?.(null);
    gallery.removeAttribute('data-coverflow-initialized');
  }

  function initGallery(gallery) {
    if (!window.Swiper || !gallery) return;

    const container = gallery.querySelector('[id^="GalleryViewer"]');
    const wrapper = gallery.querySelector('[id^="Slider-Gallery"]');
    const slides = wrapper ? Array.from(wrapper.querySelectorAll('[data-media-id]')) : [];
    if (!container || !wrapper || slides.length === 0) return;

    destroyGallery(gallery);

    container.classList.add('swiper');
    wrapper.classList.add('swiper-wrapper');
    slides.forEach((slide) => slide.classList.add('swiper-slide'));

    const activeIndex = Math.max(
      0,
      slides.findIndex((slide) => slide.classList.contains('is-active'))
    );

    container.addEventListener(
      'click',
      (event) => {
        const slide = event.target.closest('.swiper-slide');
        if (!slide || !container.contains(slide)) return;
        const swiper = gallery.coverflowSwiper;
        if (!swiper || swiper.destroyed) return;

        const clickedIndex = swiper.slides.indexOf(slide);
        if (clickedIndex >= 0 && clickedIndex !== swiper.activeIndex) {
          event.preventDefault();
          event.stopPropagation();
          swiper.slideTo(clickedIndex);
        }
      },
      true
    );

    const swiper = new window.Swiper(container, {
      effect: prefersReducedMotion.matches ? 'slide' : 'coverflow',
      centeredSlides: true,
      slidesPerView: 'auto',
      initialSlide: activeIndex,
      grabCursor: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      speed: prefersReducedMotion.matches ? 0 : 600,
      threshold: 6,
      preventClicks: false,
      preventClicksPropagation: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      navigation: {
        prevEl: gallery.querySelector('.product-coverflow__button--prev'),
        nextEl: gallery.querySelector('.product-coverflow__button--next'),
      },
      a11y: {
        enabled: true,
        prevSlideMessage: '前の商品画像へ',
        nextSlideMessage: '次の商品画像へ',
        firstSlideMessage: '最初の商品画像です',
        lastSlideMessage: '最後の商品画像です',
      },
      coverflowEffect: {
        rotate: 28,
        stretch: -10,
        depth: 100,
        scale: 0.9,
        modifier: 1.08,
        slideShadows: false,
      },
      breakpoints: {
        750: {
          coverflowEffect: {
            rotate: 56,
            stretch: -22,
            depth: 140,
            scale: 0.88,
            modifier: 1.12,
            slideShadows: false,
          },
        },
        990: {
          coverflowEffect: {
            rotate: 64,
            stretch: -34,
            depth: 160,
            scale: 0.86,
            modifier: 1.16,
            slideShadows: false,
          },
        },
      },
      on: {
        init(swiperInstance) {
          activateFromSwiper(gallery, swiperInstance);
        },
        slideChange(swiperInstance) {
          window.pauseAllMedia?.();
          activateFromSwiper(gallery, swiperInstance);
        },
      },
    });

    gallery.setCoverflowSwiper?.(swiper);
    gallery.setAttribute('data-coverflow-initialized', 'true');
  }

  function initAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(SELECTOR).forEach(destroyGallery);
  });
})();
